<template>
    <div>
        <div class="content">
            <MiddleTitle title='成绩记录'></MiddleTitle>
        </div>
        <template v-if="grade7.length">
            <div class="content contentStudentGrade" v-for="(value,index) in grade7" :key="'g7'+index">
                <SmallTitle title='中考' v-if="index==0"></SmallTitle>
                <div class="gradeBox">
                    <p>
                        <span>学期：{{value.gradeName}}</span>
                        <span>考试：{{value.nameName}}</span>
                        <span>年级排名：{{value.totalRank}}</span>
                    </p>
                    <ul>
                        <li v-for="(val,idx) in value.subject" :key="idx">
                            {{val.subject}}：{{val.score}}分/{{val.rank}}名
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-if="grade1.length">
            <div class="content contentStudentGrade" v-for="(value,index) in grade1" :key="'g1'+index">
                <SmallTitle title='初一' v-if="index==0"></SmallTitle>
                <div class="gradeBox">
                    <p>
                        <span>学期：{{value.gradeName}}</span>
                        <span>考试：{{value.nameName}}</span>
                        <span>年级排名：{{value.totalRank}}</span>
                    </p>
                    <ul>
                        <li v-for="(val,idx) in value.subject" :key="idx">
                            {{val.subject}}：{{val.score}}分/{{val.rank}}名
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-if="grade2.length">
            <div class="content contentStudentGrade" v-for="(value,index) in grade2" :key="'g2'+index">
                <SmallTitle title='初二' v-if="index==0"></SmallTitle>
                <div class="gradeBox">
                    <p>
                        <span>学期：{{value.gradeName}}</span>
                        <span>考试：{{value.nameName}}</span>
                        <span>年级排名：{{value.totalRank}}</span>
                    </p>
                    <ul>
                        <li v-for="(val,idx) in value.subject" :key="idx">
                            {{val.subject}}：{{val.score}}分/{{val.rank}}名
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-if="grade3.length">
            <div class="content contentStudentGrade" v-for="(value,index) in grade3" :key="'g3'+index">
                <SmallTitle title='初三' v-if="index==0"></SmallTitle>
                <div class="gradeBox">
                    <p>
                        <span>学期：{{value.gradeName}}</span>
                        <span>考试：{{value.nameName}}</span>
                        <span>年级排名：{{value.totalRank}}</span>
                    </p>
                    <ul>
                        <li v-for="(val,idx) in value.subject" :key="idx">
                            {{val.subject}}：{{val.score}}分/{{val.rank}}名
                        </li>
                    </ul>
                </div>
            </div>
        </template>
      <template v-if="grade4.length">
        <div class="content contentStudentGrade" v-for="(value,index) in grade4" :key="'g4'+index">
          <SmallTitle title='高一' v-if="index==0"></SmallTitle>
          <div class="gradeBox">
            <p>
              <span>学期：{{value.gradeName}}</span>
              <span>考试：{{value.nameName}}</span>
              <span>年级排名：{{value.totalRank}}</span>
            </p>
            <ul>
              <li v-for="(val,idx) in value.subject" :key="idx">
                {{val.subject}}：{{val.score}}分/{{val.rank}}名
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="grade5.length">
        <div class="content contentStudentGrade" v-for="(value,index) in grade5" :key="'g5'+index">
          <SmallTitle title='高二' v-if="index==0"></SmallTitle>
          <div class="gradeBox">
            <p>
              <span>学期：{{value.gradeName}}</span>
              <span>考试：{{value.nameName}}</span>
              <span>年级排名：{{value.totalRank}}</span>
            </p>
            <ul>
              <li v-for="(val,idx) in value.subject" :key="idx">
                {{val.subject}}：{{val.score}}分/{{val.rank}}名
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="grade6.length">
        <div class="content contentStudentGrade" v-for="(value,index) in grade6" :key="'g6'+index">
          <SmallTitle title='高三' v-if="index==0"></SmallTitle>
          <div class="gradeBox">
            <p>
              <span>学期：{{value.gradeName}}</span>
              <span>考试：{{value.nameName}}</span>
              <span>年级排名：{{value.totalRank}}</span>
            </p>
            <ul>
              <li v-for="(val,idx) in value.subject" :key="idx">
                {{val.subject}}：{{val.score}}分/{{val.rank}}名
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
export default {
    props: ['baseInfoScoreRecord'],
    name: 'pageGradeList',
    components: {
        BigTitle,MiddleTitle,SmallTitle
    },
    data() {
        return {
        }
    },
    computed: {
        grade1() {
            let grade1 = [];
            if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
                this.baseInfoScoreRecord.forEach((item,index)=>{
                    if(item.grade==1||item.grade==2) {
                        grade1.push(item);
                    }
                })
            }
            return grade1;
        },
        grade2() {
            let grade2 = [];
            if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
                this.baseInfoScoreRecord.forEach((item,index)=>{
                    if(item.grade==3||item.grade==4) {
                        grade2.push(item);
                    }
                })
            }
            return grade2
        },
        grade3() {
            let grade3 = [];
            if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
                this.baseInfoScoreRecord.forEach((item,index)=>{
                    if(item.grade==5||item.grade==6) {
                        grade3.push(item);
                    }
                })
            }
            return grade3
        },
        grade4() {
          let grade4 = [];
          if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
            this.baseInfoScoreRecord.forEach((item,index)=>{
              if(item.grade==7||item.grade==8) {
                grade4.push(item);
              }
            })
          }
          return grade4;
        },
        grade5() {
          let grade5 = [];
          if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
            this.baseInfoScoreRecord.forEach((item,index)=>{
              if(item.grade==9||item.grade==10) {
                grade5.push(item);
              }
            })
          }
          return grade5
        },
        grade6() {
          let grade6 = [];
          if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
            this.baseInfoScoreRecord.forEach((item,index)=>{
              if(item.grade==11||item.grade==12) {
                grade6.push(item);
              }
            })
          }
          return grade6
        },
        grade7() {
            // 中考
            let grade7 = [];
            if(Array.isArray(this.baseInfoScoreRecord)&&this.baseInfoScoreRecord.length) {
                this.baseInfoScoreRecord.forEach((item,index)=>{
                    if(item.grade=='middle') {
                        grade7.push(item);
                    }
                })
            }
            return grade7
        },
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>